(function() {
  var overlay = document.getElementById('rq-overlay');
  if (!overlay) return;
  var poolsMf = JSON.parse(document.getElementById('rq-sets').textContent || '{}');
  var current = JSON.parse(document.getElementById('rq-current').textContent);
  var chosenGoal = null;
  var chosenTime = null;
  var cache = {};
  var TOWELS = 'reczniki-jednorazowe-do-twarzy';

  var SLOT = {
    'step-1-zel-myjacy': 'c',
    'step-1-pianka-oczyszczajaca-z-glikolipidami': 'c',
    'routines-balsam-do-demakijazu-oczyszczajacy-nawilzajacy-step-1-100ml': 'c',
    'routines-maselko-do-demakijazu-twarzy-oczu-i-zmywania-spf-step-1-60ml': 'c',
    'next-gen-galaretka-myjaca-jelly-face-wash': 'c',
    'mgielka-tonizujaca': 't',
    'step-2-mgielka-aloesowa': 't',
    'step-2-tonik-mikrozluszczajacy-rozjasnienie-przebarwien-step-5-50ml': 't',
    'step-2-tonik-rozswietlajacy-z-witamina-c': 't',
    'next-gen-mgielka-seboregulujaca': 't',
    'routines-serum-wodne-ai-przeciw-niedoskonalosciom-step-3-30ml': 's',
    'routines-serum-z-kwasem-azelainowym-regulacja-sebum-step-3-30ml': 's',
    'routines-serum-z-biofermentami-lagodzace-regenerujace-step-3-30ml': 's',
    'routines-serum-z-witamina-c-redukujace-zaczerwienienia-step-3-30ml': 's',
    'routines-booster-energetyzujacy-na-dzien-na-zmarszczki-step-3-50ml': 's',
    'routines-krem-nawilzajacy-lagodzacy-step-4-50ml': 'd',
    'routines-krem-rozswietlajacy-na-dzien-efekt-glow-step-4-50ml': 'd',
    'routines-krem-cc-redukujacy-zaczerwienienia-na-dzien-step-4-50ml': 'd',
    'next-gen-zielony-zel-krem-seboregulujacy': 'd',
    'next-gen-niebieski-pudding-krem-nawilzajacy': 'd',
    'routines-krem-ceramidowy-na-noc-regenerujacy-step-4-50ml': 'n',
    'step-4-krem-odzywczy-z-wit-b12-ceramidami-i-kwasem-hialuronowym': 'n',
    'routines-krem-z-filtrem-ochrona-uv-spf-50-step-4-50ml': 'spf',
    'step-4-krem-matujacy-spf-50': 'spf',
    'sztyft-nawilzajacy-spf-50': 'spf',
    'sztyft-lagodzacy-spf-50': 'spf',
    'sztyft-spf-50-glow-stick': 'spf',
    'routines-peeling-kwasowy-na-noc-eksfoliacja-step-5-30ml': 'p',
    'routines-peeling-enzymatyczny-delikatnie-zluszczajacy-step-5-50ml': 'p',
    'routines-maska-jogurtowa-lagodzaca-na-dzien-step-6-50ml': 'm',
    'routines-maska-nocna-relaksujaca-na-noc-step-6-50ml': 'm',
    'step-4-eye-cream': 'e',
    'next-gen-plasterki-hydrokoloidowe-na-wypryski-24-szt': 'x',
    'mgielka-glow-do-twarzy-i-ciala': 'x'
  };

  var TIME = {
    'routines-krem-z-filtrem-ochrona-uv-spf-50-step-4-50ml': 'day',
    'step-4-krem-matujacy-spf-50': 'day',
    'sztyft-nawilzajacy-spf-50': 'day',
    'sztyft-lagodzacy-spf-50': 'day',
    'sztyft-spf-50-glow-stick': 'day',
    'routines-krem-rozswietlajacy-na-dzien-efekt-glow-step-4-50ml': 'day',
    'routines-krem-cc-redukujacy-zaczerwienienia-na-dzien-step-4-50ml': 'day',
    'next-gen-zielony-zel-krem-seboregulujacy': 'day',
    'next-gen-mgielka-seboregulujaca': 'day',
    'routines-maska-jogurtowa-lagodzaca-na-dzien-step-6-50ml': 'day',
    'routines-booster-energetyzujacy-na-dzien-na-zmarszczki-step-3-50ml': 'day',
    'mgielka-glow-do-twarzy-i-ciala': 'day',
    'routines-krem-ceramidowy-na-noc-regenerujacy-step-4-50ml': 'night',
    'step-4-krem-odzywczy-z-wit-b12-ceramidami-i-kwasem-hialuronowym': 'night',
    'routines-maska-nocna-relaksujaca-na-noc-step-6-50ml': 'night',
    'routines-peeling-kwasowy-na-noc-eksfoliacja-step-5-30ml': 'night',
    'step-2-tonik-mikrozluszczajacy-rozjasnienie-przebarwien-step-5-50ml': 'night',
    'next-gen-plasterki-hydrokoloidowe-na-wypryski-24-szt': 'night'
  };

  var EXFOLIANT = {
    'step-2-tonik-mikrozluszczajacy-rozjasnienie-przebarwien-step-5-50ml': true,
    'routines-peeling-kwasowy-na-noc-eksfoliacja-step-5-30ml': true,
    'routines-peeling-enzymatyczny-delikatnie-zluszczajacy-step-5-50ml': true
  };

  var FILL_ORDER = {
    rano: ['s', 'spf', 't', 'd', 'e', 'x'],
    wieczor: ['s', 'n', 't', 'p', 'm', 'e', 'x'],
    pelna: ['s', 'spf', 'n', 't', 'd', 'p', 'm', 'e', 'x']
  };
  var ALLOWED = {
    rano: ['c', 't', 's', 'd', 'spf', 'e', 'x'],
    wieczor: ['c', 't', 's', 'n', 'p', 'm', 'e', 'x'],
    pelna: ['c', 't', 's', 'd', 'n', 'spf', 'p', 'm', 'e', 'x']
  };
  var TIME_OF = { rano: 'day', wieczor: 'night', pelna: null };
  var CEL_LABEL = { nawilzenie: 'Nawilżenie i regeneracja', niedoskonalosci: 'Niedoskonałości i sebum', ukojenie: 'Ukojenie i zaczerwienienia', blask: 'Rozświetlenie i anti-aging' };
  var PORA_LABEL = { rano: 'Poranna', wieczor: 'Wieczorna', pelna: 'Pełna (dzień i noc)' };

  var REASONS = {
    nawilzenie: {
      'routines-serum-z-biofermentami-lagodzace-regenerujace-step-3-30ml': 'Wzmacnia barierę hydrolipidową i głęboko koi.',
      'routines-krem-nawilzajacy-lagodzacy-step-4-50ml': 'Zamyka rutynę warstwą intensywnego nawilżenia.',
      'routines-krem-ceramidowy-na-noc-regenerujacy-step-4-50ml': 'Odbudowuje ceramidy i regeneruje skórę w nocy.',
      'routines-krem-z-filtrem-ochrona-uv-spf-50-step-4-50ml': 'Filtr SPF 50 chroni przed UV i przesuszeniem.',
      'routines-balsam-do-demakijazu-oczyszczajacy-nawilzajacy-step-1-100ml': 'Delikatnie oczyszcza, nie wysuszając skóry.',
      'step-1-zel-myjacy': 'Łagodne mycie na start rutyny.',
      'step-2-mgielka-aloesowa': 'Aloes przygotowuje skórę do wchłaniania serum.',
      'mgielka-tonizujaca': 'Tonizuje i nawadnia po oczyszczaniu.',
      'routines-maska-nocna-relaksujaca-na-noc-step-6-50ml': 'Dodatkowa dawka regeneracji podczas snu.',
      'next-gen-niebieski-pudding-krem-nawilzajacy': 'Lekki krem-pudding intensywnie nawilża.',
      'step-4-eye-cream': 'Nawilża delikatną okolicę oczu.',
      'next-gen-galaretka-myjaca-jelly-face-wash': 'Myje bez uczucia ściągnięcia skóry.'
    },
    niedoskonalosci: {
      'routines-serum-wodne-ai-przeciw-niedoskonalosciom-step-3-30ml': 'Aktywnie redukuje niedoskonałości i wypryski.',
      'step-2-tonik-mikrozluszczajacy-rozjasnienie-przebarwien-step-5-50ml': 'Odblokowuje pory i rozjaśnia ślady po wypryskach.',
      'step-1-pianka-oczyszczajaca-z-glikolipidami': 'Głęboko oczyszcza pory z sebum i zanieczyszczeń.',
      'next-gen-zielony-zel-krem-seboregulujacy': 'Matuje i nie zapycha porów w ciągu dnia.',
      'step-4-krem-matujacy-spf-50': 'Matująca ochrona SPF 50 bez zapychania porów.',
      'next-gen-niebieski-pudding-krem-nawilzajacy': 'Nawilża na noc, nie obciążając cery.',
      'next-gen-plasterki-hydrokoloidowe-na-wypryski-24-szt': 'SOS na pojedyncze wypryski — przyspiesza gojenie.',
      'routines-serum-z-kwasem-azelainowym-regulacja-sebum-step-3-30ml': 'Kwas azelainowy reguluje sebum i łagodzi stany zapalne.',
      'routines-peeling-kwasowy-na-noc-eksfoliacja-step-5-30ml': 'Nocna eksfoliacja wygładza i oczyszcza pory.',
      'next-gen-mgielka-seboregulujaca': 'Kontroluje błyszczenie się skóry w ciągu dnia.',
      'next-gen-galaretka-myjaca-jelly-face-wash': 'Łagodnie myje skórę skłonną do niedoskonałości.',
      'routines-krem-ceramidowy-na-noc-regenerujacy-step-4-50ml': 'Odbudowuje barierę osłabioną przez aktywne składniki.'
    },
    ukojenie: {
      'routines-serum-z-biofermentami-lagodzace-regenerujace-step-3-30ml': 'Łagodzi podrażnienia i wspiera regenerację.',
      'routines-krem-cc-redukujacy-zaczerwienienia-na-dzien-step-4-50ml': 'Optycznie redukuje zaczerwienienia i chroni w dzień.',
      'routines-krem-ceramidowy-na-noc-regenerujacy-step-4-50ml': 'Nocna odbudowa bariery ochronnej skóry.',
      'sztyft-lagodzacy-spf-50': 'Łagodząca ochrona SPF 50 dla skóry wrażliwej.',
      'step-2-mgielka-aloesowa': 'Aloes natychmiast koi i zmniejsza podrażnienia.',
      'routines-balsam-do-demakijazu-oczyszczajacy-nawilzajacy-step-1-100ml': 'Bardzo delikatny demakijaż bez podrażniania.',
      'routines-maska-jogurtowa-lagodzaca-na-dzien-step-6-50ml': 'Jogurtowa formuła koi i wycisza skórę.',
      'routines-peeling-enzymatyczny-delikatnie-zluszczajacy-step-5-50ml': 'Enzymy złuszczają bez mechanicznego drażnienia.',
      'routines-krem-nawilzajacy-lagodzacy-step-4-50ml': 'Łagodzący krem wzmacnia barierę ochronną.',
      'step-1-zel-myjacy': 'Delikatne mycie dla skóry reaktywnej.',
      'mgielka-tonizujaca': 'Delikatnie tonizuje bez podrażnień.',
      'routines-serum-z-witamina-c-redukujace-zaczerwienienia-step-3-30ml': 'Redukuje zaczerwienienia i wyrównuje koloryt.'
    },
    blask: {
      'routines-serum-z-witamina-c-redukujace-zaczerwienienia-step-3-30ml': 'Witamina C rozświetla i wyrównuje koloryt.',
      'step-2-tonik-rozswietlajacy-z-witamina-c': 'Tonik z witaminą C dodaje skórze blasku.',
      'routines-krem-rozswietlajacy-na-dzien-efekt-glow-step-4-50ml': 'Efekt glow i promienne wykończenie na dzień.',
      'sztyft-spf-50-glow-stick': 'Ochrona SPF 50 z efektem glow.',
      'step-4-krem-odzywczy-z-wit-b12-ceramidami-i-kwasem-hialuronowym': 'Odżywia i regeneruje w nocy, poprawiając koloryt.',
      'routines-peeling-enzymatyczny-delikatnie-zluszczajacy-step-5-50ml': 'Usuwa martwy naskórek, przywracając blask.',
      'step-4-eye-cream': 'Rozświetla i wygładza okolicę oczu.',
      'step-1-zel-myjacy': 'Czysta skóra to podstawa promiennej cery.',
      'routines-maselko-do-demakijazu-twarzy-oczu-i-zmywania-spf-step-1-60ml': 'Dokładny demakijaż to podstawa promiennej cery.',
      'routines-booster-energetyzujacy-na-dzien-na-zmarszczki-step-3-50ml': 'Energetyzuje i wygładza pierwsze zmarszczki.',
      'routines-krem-ceramidowy-na-noc-regenerujacy-step-4-50ml': 'Nocna regeneracja poprawia gęstość skóry.',
      'mgielka-glow-do-twarzy-i-ciala': 'Rozświetlające drobinki na twarz i ciało.'
    }
  };
  var EXTRA_REASONS = {};
  EXTRA_REASONS[TOWELS] = 'Higieniczne osuszanie twarzy po każdym oczyszczaniu.';

  var DEFAULT_POOLS = window.RQ_DEFAULT_POOLS || {};

  function onReady(fn) { if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }
  onReady(function() {
    var cardEl = document.querySelector('.rq-card');
    var avail = document.querySelector('.product-availability-wrapper');
    if (cardEl && avail && avail.parentNode === cardEl.parentNode) {
      avail.parentNode.insertBefore(cardEl, avail.nextSibling);
    }
    fixWishlistButton();
  });

  // ---- Klaviyo: zdarzenia onsite ----
  function track(nazwa, wlasciwosci) {
    try {
      var p = wlasciwosci || {};
      if (window.klaviyo && typeof window.klaviyo.push === 'function') { window.klaviyo.push(['track', nazwa, p]); }
      else { window._learnq = window._learnq || []; window._learnq.push(['track', nazwa, p]); }
    } catch (e) {}
  }
  function trackProduct(p) {
    return {
      Nazwa: p.title,
      Uchwyt: p.handle,
      ProductID: p.pid || null,
      Cena: (p.price || 0) / 100,
      URL: window.location.origin + '/products/' + p.handle,
      Zdjecie: p.image || null
    };
  }

  // ---- Oznaczanie koszyka zrodlem (widoczne pozniej w zamowieniu w panelu) ----
  function oznaczKoszyk(zrodlo, dodatkowe) {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var obecne = ((cart.attributes || {})['Zrodlo zestawu'] || '').split(', ').filter(Boolean);
        if (obecne.indexOf(zrodlo) === -1) obecne.push(zrodlo);
        var attrs = { 'Zrodlo zestawu': obecne.join(', ') };
        if (dodatkowe) { for (var k in dodatkowe) { if (dodatkowe[k]) attrs[k] = dodatkowe[k]; } }
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function() {});
  }
  function atrybutyQuizu() {
    return { 'Quiz - cel': CEL_LABEL[chosenGoal] || '', 'Quiz - pora dnia': PORA_LABEL[chosenTime] || '' };
  }

  // ---- Lista ulubionych: integracja z natywnym mechanizmem motywu Ecomus ----
  var WIS_KEY = 'theme4:wishlist:id';
  function wisRead() {
    var el = document.querySelector('hdt-wishlist');
    if (el && Array.isArray(el.array)) return el.array;
    var raw = localStorage.getItem(WIS_KEY);
    return raw ? raw.split(',') : [];
  }
  function wisPersist(arr) {
    localStorage.setItem(WIS_KEY, arr.join(','));
    document.querySelectorAll('hdt-wishlist[data-id]').forEach(function(el) {
      el.setAttribute('action', arr.indexOf(el.getAttribute('data-id')) > -1 ? 'added' : 'add');
    });
    document.dispatchEvent(new CustomEvent('theme4:wishlist:update', { bubbles: true, detail: 'the4' }));
  }
  function wisHas(id) { return !!id && wisRead().indexOf(String(id)) > -1; }
  function wisAdd(ids) {
    var arr = wisRead(), added = 0;
    ids.forEach(function(id) {
      id = String(id);
      if (id && arr.indexOf(id) === -1) { arr.unshift(id); added++; }
    });
    wisPersist(arr);
    return added;
  }
  function wisToggle(id) {
    id = String(id);
    var arr = wisRead(), i = arr.indexOf(id);
    if (i > -1) { arr.splice(i, 1); } else { arr.unshift(id); }
    wisPersist(arr);
    return i === -1;
  }

  function fixWishlistButton() {
    var old = document.getElementById('wishlist-trigger');
    if (!old || !current.pid) return;
    var btn = old.cloneNode(true);
    old.parentNode.replaceChild(btn, old);
    var pid = String(current.pid);
    function paint() { btn.classList.toggle('is-active', wisHas(pid)); }
    paint();
    btn.addEventListener('click', function() {
      var dodano = wisToggle(pid);
      paint();
      if (dodano) {
        track('Dodanie do ulubionych', {
          Zrodlo: 'Karta produktu',
          LiczbaProduktow: 1,
          WartoscZestawu: (current.price || 0) / 100,
          $value: (current.price || 0) / 100,
          Produkty: [trackProduct(current)]
        });
      }
    });
    document.addEventListener('theme4:wishlist:update', paint);
    migrateOldWishlist();
  }

  function migrateOldWishlist() {
    var raw = localStorage.getItem('shopify-wishlist');
    if (!raw) return;
    var handles = [];
    try { handles = JSON.parse(raw) || []; } catch (e) { localStorage.removeItem('shopify-wishlist'); return; }
    if (!handles.length) { localStorage.removeItem('shopify-wishlist'); return; }
    Promise.all(handles.map(fetchProduct)).then(function(items) {
      var ids = items.filter(Boolean).map(function(i) { return i.pid; }).filter(Boolean);
      if (ids.length) wisAdd(ids);
      localStorage.removeItem('shopify-wishlist');
    });
  }

  function poolFor(goal) {
    var out = (poolsMf[goal] || []).slice();
    (DEFAULT_POOLS[goal] || []).forEach(function(h) { if (out.indexOf(h) === -1) out.push(h); });
    return out;
  }

  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function slotOf(h) { return SLOT[h] || 'x'; }
  function timeOk(h) {
    var want = TIME_OF[chosenTime];
    if (!want) return true;
    var t = TIME[h];
    return !t || t === want;
  }
  var SLOT_RANK = { c: 1, t: 2, s: 3, d: 4, n: 4, spf: 4, e: 4, p: 5, m: 6, x: 7 };
  function stepOf(p) {
    if (p.handle === TOWELS) return 1.5;
    var m = /STEP *([0-9])/i.exec(p.title || '');
    if (m) return parseInt(m[1], 10);
    return SLOT_RANK[slotOf(p.handle)] || 7;
  }

  function show(step) {
    overlay.querySelectorAll('.rq-step').forEach(function(s) { s.hidden = s.getAttribute('data-rq-step') !== String(step); });
  }
  function open() {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    show(1);
    track('Rozpoczęcie quizu rutyny', {
      Produkt: current.title,
      Uchwyt: current.handle,
      ProductID: current.pid || null,
      URL: window.location.href
    });
  }
  function close() { overlay.hidden = true; document.body.style.overflow = ''; }

  document.getElementById('rq-open').addEventListener('click', open);
  document.getElementById('rq-close').addEventListener('click', close);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
  overlay.querySelectorAll('[data-rq-back]').forEach(function(b) {
    b.addEventListener('click', function() { show(this.getAttribute('data-rq-back')); });
  });
  overlay.querySelectorAll('.rq-opt[data-goal]').forEach(function(b) {
    b.addEventListener('click', function() { chosenGoal = this.getAttribute('data-goal'); show(2); });
  });
  overlay.querySelectorAll('.rq-opt[data-time]').forEach(function(b) {
    b.addEventListener('click', function() { chosenTime = this.getAttribute('data-time'); show(3); });
  });
  overlay.querySelectorAll('.rq-opt[data-size]').forEach(function(b) {
    b.addEventListener('click', function() { show(4); loadResults(parseInt(this.getAttribute('data-size'), 10)); });
  });

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function(r) { if (!r.ok) throw new Error(handle); return r.json(); })
      .then(function(p) {
        var item = {
          handle: handle,
          variant: p.variants[0].id,
          pid: p.id,
          title: p.title,
          price: p.variants[0].price,
          compare: p.variants[0].compare_at_price || null,
          image: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '',
          available: p.available
        };
        cache[handle] = item;
        return item;
      })
      .catch(function() { return null; });
  }

  function pickSet(available, size) {
    var chosen = [];
    var used = {};
    var allowed = ALLOWED[chosenTime];
    var exfoUsed = EXFOLIANT[current.handle] === true;
    var viewedSlot = slotOf(current.handle);
    if (viewedSlot !== 'x') used[viewedSlot] = true;
    var need = size - 1;

    function tryTake(slot) {
      if (allowed.indexOf(slot) === -1) return false;
      if (used[slot] && slot !== 'x') return false;
      for (var i = 0; i < available.length; i++) {
        var it = available[i];
        if (chosen.indexOf(it) > -1) continue;
        if (slotOf(it.handle) !== slot) continue;
        if (!timeOk(it.handle)) continue;
        if (EXFOLIANT[it.handle] && exfoUsed) continue;
        chosen.push(it);
        if (slot !== 'x') used[slot] = true;
        if (EXFOLIANT[it.handle]) exfoUsed = true;
        return true;
      }
      return false;
    }

    if (chosen.length < need) tryTake('c');
    var order = FILL_ORDER[chosenTime];
    for (var o = 0; o < order.length && chosen.length < need; o++) tryTake(order[o]);
    for (var i = 0; i < available.length && chosen.length < need; i++) {
      var it = available[i];
      if (chosen.indexOf(it) > -1) continue;
      var s = slotOf(it.handle);
      if (allowed.indexOf(s) === -1 || !timeOk(it.handle)) continue;
      if (used[s] && s !== 'x') continue;
      if (EXFOLIANT[it.handle] && exfoUsed) continue;
      chosen.push(it);
      if (s !== 'x') used[s] = true;
      if (EXFOLIANT[it.handle]) exfoUsed = true;
    }
    return chosen;
  }

  function loadResults(size) {
    var box = document.getElementById('rq-results');
    var addBtn = document.getElementById('rq-add');
    var expressBtn = document.getElementById('rq-express');
    addBtn.hidden = true;
    expressBtn.hidden = true;
    document.getElementById('rq-save').hidden = true;
    document.getElementById('rq-saved').hidden = true;
    box.innerHTML = '<div class="rq-loading">Dobieramy produkty&hellip;</div>';

    var pool = poolFor(chosenGoal).filter(function(h) { return h !== current.handle; });
    Promise.all(pool.concat([TOWELS]).map(fetchProduct)).then(function(fetched) {
      var byHandle = {};
      fetched.forEach(function(i) { if (i && i.available) byHandle[i.handle] = i; });
      var available = pool.map(function(h) { return byHandle[h]; }).filter(Boolean);

      var chosen = pickSet(available, size);
      if (byHandle[TOWELS]) chosen.push(byHandle[TOWELS]);

      var all = [Object.assign({ isCurrent: true }, current)].concat(chosen);
      all.sort(function(a, b) { return stepOf(a) - stepOf(b); });

      var reasons = REASONS[chosenGoal] || {};
      box.innerHTML = all.map(function(p) {
        var hasSale = p.compare && p.compare > p.price;
        var priceHtml = hasSale
          ? '<s class="rq-item__compare">' + money(p.compare) + '</s><span class="rq-item__price">' + money(p.price) + '</span>'
          : '<span class="rq-item__price">' + money(p.price) + '</span>';
        var why = p.isCurrent ? '' : (reasons[p.handle] || EXTRA_REASONS[p.handle] || '');
        return '<label class="rq-item' + (p.isCurrent ? ' rq-item--current' : '') + '">' +
          '<input type="checkbox" class="rq-check" data-variant="' + p.variant + '" data-pid="' + (p.pid || '') + '" data-handle="' + p.handle + '" data-price="' + p.price + '" checked>' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="rq-noimg"></span>') +
          '<span class="rq-item__info">' +
            (p.isCurrent ? '<span class="rq-item__badge">Oglądany produkt</span>' : (p.handle === TOWELS ? '<span class="rq-item__badge">Dodatek</span>' : '')) +
            '<span class="rq-item__title">' + p.title + '</span>' +
            (why ? '<span class="rq-item__why">' + why + '</span>' : '') +
            '<span class="rq-item__pricerow">' + priceHtml + '</span>' +
          '</span>' +
        '</label>';
      }).join('');
      addBtn.hidden = false;
      expressBtn.hidden = false;
      document.getElementById('rq-save').hidden = false;
      updateTotal();
      box.querySelectorAll('.rq-check').forEach(function(c) { c.addEventListener('change', updateTotal); });

      var suma = all.reduce(function(s, p) { return s + (p.price || 0); }, 0);
      track('Wynik quizu rutyny', {
        Cel: CEL_LABEL[chosenGoal] || chosenGoal,
        PoraDnia: PORA_LABEL[chosenTime] || chosenTime,
        RozmiarRutyny: size,
        ProduktWyjsciowy: current.title,
        LiczbaProduktow: all.length,
        WartoscZestawu: suma / 100,
        $value: suma / 100,
        Produkty: all.map(trackProduct)
      });
    });
  }

  function checkedItems() {
    var items = [];
    overlay.querySelectorAll('.rq-check:checked').forEach(function(c) {
      items.push({ id: parseInt(c.getAttribute('data-variant'), 10), quantity: 1 });
    });
    return items;
  }

  function updateTotal() {
    var total = 0, count = 0;
    overlay.querySelectorAll('.rq-check:checked').forEach(function(c) { total += parseInt(c.getAttribute('data-price'), 10); count++; });
    document.getElementById('rq-add').disabled = count === 0;
    document.getElementById('rq-express').disabled = count === 0;
    document.getElementById('rq-add-label').textContent = count === 0 ? 'ZAZNACZ PRODUKTY' : 'DODAJ ZESTAW DO KOSZYKA • ' + money(total);
  }

  document.getElementById('rq-save').addEventListener('click', function() {
    var ids = [], produkty = [], suma = 0;
    overlay.querySelectorAll('.rq-check:checked').forEach(function(c) {
      var pid = c.getAttribute('data-pid');
      if (!pid) return;
      ids.push(pid);
      suma += parseInt(c.getAttribute('data-price'), 10) || 0;
      var h = c.getAttribute('data-handle');
      if (h && cache[h]) produkty.push(trackProduct(cache[h]));
      else if (h === current.handle) produkty.push(trackProduct(current));
    });
    if (!ids.length) return;
    wisAdd(ids);
    this.hidden = true;
    document.getElementById('rq-saved').hidden = false;
    track('Dodanie do ulubionych', {
      Zrodlo: 'Quiz rutyny',
      Cel: CEL_LABEL[chosenGoal] || chosenGoal,
      PoraDnia: PORA_LABEL[chosenTime] || chosenTime,
      LiczbaProduktow: ids.length,
      WartoscZestawu: suma / 100,
      $value: suma / 100,
      Produkty: produkty
    });
  });

  document.getElementById('rq-express').addEventListener('click', function() {
    var btn = this;
    var items = checkedItems();
    if (!items.length) return;
    btn.disabled = true;
    btn.textContent = 'PRZENOSIMY DO PŁATNOŚCI…';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { if (!r.ok) throw new Error('cart'); return r.json(); })
    .then(function() {
      var idz = function() { window.location.href = window.Shopify.routes.root + 'checkout'; };
      oznaczKoszyk('Quiz rutyny', atrybutyQuizu()).then(idz, idz);
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = 'SZYBKI ZAKUP';
    });
  });

  document.getElementById('rq-add').addEventListener('click', function() {
    var btn = this;
    var items = checkedItems();
    if (!items.length) return;
    btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { if (!r.ok) throw new Error('cart'); return r.json(); })
    .then(function(res) {
      oznaczKoszyk('Quiz rutyny', atrybutyQuizu());
      document.getElementById('rq-add-label').textContent = 'DODANO \uD83D\uDC4D';
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: res } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function() {
        close();
        btn.disabled = false;
        var drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
        if (drawer) {
          if (typeof drawer.open === 'function') { drawer.open(); }
          else { drawer.setAttribute('open', ''); drawer.classList.add('active'); }
        }
      }, 1200);
    })
    .catch(function() {
      btn.disabled = false;
      document.getElementById('rq-add-label').textContent = 'SPRÓBUJ PONOWNIE';
    });
  });
})();
